import React from 'react';
import { Modal, Form, FormInstance } from 'antd';
import CounterpartyForm from './CounterpartyForm';
import { CounterpartyDtoRequest } from '../../../../interfaces/CounterpartyDtos';

interface CounterpartyModalProps {
    visible: boolean;
    type: 'add' | 'edit';
    parentForm?: FormInstance<any>;
    onClose: () => void;
    onSubmit: (values: CounterpartyDtoRequest) => void;
}

const CounterpartyModal: React.FC<CounterpartyModalProps> = ({ visible, type, onClose, onSubmit, parentForm }) => {
    const [form] = Form.useForm();

    const customForm = parentForm ? parentForm : form;

    const handleOk = () => {
        customForm.submit();
    };

    return (
        <Modal
            title={type === 'add' ? 'Добавление контрагента' : 'Редактирование контрагента'}
            open={visible}
            onOk={handleOk}
            onCancel={onClose}
            okText="Добавить"
            cancelText="Отмена"
            width="70%"
            style={{ top: 10 }}
            maskClosable={true}
        >
            <CounterpartyForm form={customForm} onFinish={onSubmit} />
        </Modal>
    );
};

export default CounterpartyModal;